var cilArrowThickLeft = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M294.637,496l-38.688-.035L16,255.729,256.334,16.048h38.277l.008,143.937H494.636v192H294.629ZM61.271,255.773l201.364,201.6-.008-137.391H462.636v-128H262.621l-.008-137.006Z' class='ci-primary'/>"];

export { cilArrowThickLeft };

